import TextareaAutosize from 'react-textarea-autosize';

import style from './Textarea.module.scss';

function Textarea(props) {
  const maxRowsText = 10;

  return (
    <>
      <TextareaAutosize
        placeholder={props.placeholder}
        className={style.textarea}
        {...props.register}
        maxRows={maxRowsText}
      />
      <label className={style.textareaLabel}>{props.label}</label>
      {Boolean(props.errors) && <span className={style.textareaError}>{props.errors && props.errorLabel}</span>}
    </>
  );
}

export default Textarea;
